import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared-services/api/api/api.service';
import { SharedDataService } from 'src/app/shared-services/shared-data/shared-data.service';
import { ToasterService } from 'src/app/shared-services/toaster/toaster.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-group-report-ipv',
  templateUrl: './group-report-ipv.component.html',
  styleUrls: ['./group-report-ipv.component.scss'],
})
export class GroupReportIpvComponent implements OnInit {
  isLoading = false;
  reportData: any;
  personaKey = 3;
  assessmentId = this._route.snapshot.params.id;
  SERVER_URL = environment.apiPath;
  subs: Subscription;
  job_title = '';
  constructor(
    private _route: ActivatedRoute,
    private _api: ApiService,
    private _toastr: ToasterService,
    private _router: Router,
    private sharedService: SharedDataService,
  ) {}

  ngOnInit(): void {
    // const assessmentId = this._route.snapshot.params.id;

    this.subs = this.sharedService.CandidatesSharedData.subscribe((res) => {
      this.job_title = res.job_title;
    });

    if (this.assessmentId) {
      this.isLoading = true;
      this._api.getAnalyticReport(this.assessmentId).subscribe((res) => {
        console.log('resL ', res);

        this.reportData = res;
        this.isLoading = false;
      });
    } else {
      this._router.navigate(['candidate/list-candidates']);
    }
  }

  changeLabelOfPersonaData(index) {
    this.personaKey = index;
  }

  getColorClass(percentage) {
    if (percentage < 33) {
      return 'red';
    }
    if (percentage < 66 && percentage >= 33) {
      return 'orange';
    }
    if (percentage <= 100 && percentage >= 66) {
      return 'green';
    }
  }

  // downloadAnalyticExcel() {
  //   this._api
  //     .downloadAnalyticExcel(this._route.snapshot.params.id)
  //     .subscribe((_1) => {
  //       this._toastr.showSuccess('Download Started ...');
  //     });
  // }

  getCircle(score) {
    if (score < 34) {
      return 'circle-red';
    } else {
      if (score >= 34 && score < 67) {
        return 'circle-orange';
      } else {
        return 'circle-green';
      }
    }
  }

  getClassNameForScore(score) {
    if (score < 20) {
      return 'veryLow-bg';
    }

    if (score >= 20 && score < 40) {
      return 'low-bg';
    }

    if (score >= 40 && score < 60) {
      return 'medium-bg';
    }

    if (score >= 60 && score < 80) {
      return 'high-bg';
    }

    if (score >= 80 && score <= 100) {
      return 'veryHigh-bg';
    }
  }

  getNameFromScore(score) {
    if (score < 20) {
      return 'Very Low';
    }

    if (score >= 20 && score < 40) {
      return 'Low';
    }

    if (score >= 40 && score < 60) {
      return 'Medium';
    }

    if (score >= 60 && score < 80) {
      return 'High';
    }

    if (score >= 80 && score <= 100) {
      return 'Very High';
    }
  }
}
